import { times } from "lodash";
import { IGoodsClassified2ViewDTO, IGoodsConvolution, IGoodsDTO, IGoodsViewDTO, IGoodsWtruCodeGroupDTO } from "../../libs/coreapi-dto/dirs/goods";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";
import { IGoodsByIdDTO } from "../../libs/core-api-requests/dirs/goodsRequest";

export class GoodsDataProvider extends DictionaryDataProvider<IGoodsViewDTO, IGoodsDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<IGoodsViewDTO, IGoodsDTO>> {
        return this._coreApiService.goodsRequest
    }

    attachToGroup(idGoodsGlobal: string, idGoodsGroupGlobal: string, callback: (e) => void) {
        this._coreApiService.goodsRequest
            .then(r => r
                .attachToGroup(idGoodsGlobal, idGoodsGroupGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e)
                    }
                    else
                        throw new Error(e.message.title);
                })
            );
    }

    getByIdAndScalingRatio(idGlobal: string, idScalingRatio: string, callback?: (entity: IGoodsDTO) => void, report?: (value) => void) {
        this.getDataRequest()
            .then(r =>
                r.getByIdAndScalingRatio(idGlobal, idScalingRatio, (e) => {
                    if (e.respType === 'isCompleted')
                        callback?.(e.data);
                    else
                        throw new Error(e.message.text);
                }, (value) => report?.(value))
            );
    }

    getByManyId(ids: string[], callback?: (e: IGoodsDTO[]) => void, signal?: AbortSignal | null) {
        this._coreApiService.goodsRequest
            .then(r => r
                .getByManyId(ids, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e.data);
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e?.message.title ?? 'DictionaryDataProvider getViewByName !isCompleted');
                },signal)
            )
            .catch((e) => {
                throw new Error(e?.message.text ?? 'getByManyId DictionaryDataProvider')
            });
    }

    moveFromGroup(idGoodsGlobal: string, fromIdGoodsGroupGlobal: string, toIdGoodsGroupGlobal: string, callback: (e) => void) {
        this._coreApiService.goodsRequest
            .then(r => r
                .moveFromGroup(idGoodsGlobal, fromIdGoodsGroupGlobal, toIdGoodsGroupGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e)
                    }
                    else
                        throw new Error(e.message.title);
                })
            );
    }

    detachFromGroup(idGoodsGlobal: string, idGoodsGroupGlobal: string, callback: (e) => void) {
        this._coreApiService.goodsRequest
            .then(r => r
                .detachFromGroup(idGoodsGlobal, idGoodsGroupGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e)
                    }
                    else
                        throw new Error(e.message.title);
                })
            );
    }

    attachToClassifier(idGoodsGlobal: string, idGoodsClassifierGlobal: string, callback?: (e: any) => void): Promise<void> {
        return new Promise((resolve, reject) => {
            this._coreApiService.goodsRequest
                .then(r => {
                    r.attachToClassifier(idGoodsGlobal, idGoodsClassifierGlobal, (e) => {
                        if (e.respType === 'isCompleted') {
                            try {
                                callback?.(e);
                                resolve();
                            } catch (error) {
                                reject(error);
                            }
                        }
                        else {
                            reject(new Error(e?.message?.title ?? 'GoodsDataProvider attachToClassifier !isCompleted'));
                        }
                    });
                })
                .catch((e) => {
                    reject(new Error(e?.message?.text ?? e?.message ?? 'attachToClassifier GoodsDataProvider error'));
                });
        });
    }

    moveFromClassifier(idGoodsGlobal: string, fromIdGoodsClassifierGlobal: string, toIdGoodsClassifierGlobal: string, callback: (e) => void) {
        this._coreApiService.goodsRequest
            .then(r => r
                .moveFromClassifier(idGoodsGlobal, fromIdGoodsClassifierGlobal, toIdGoodsClassifierGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e)
                    }
                    else
                        throw new Error(e.message.title);
                })
            );
    }

    detachFromClassifier(idGoodsGlobal: string, idGoodsClassifierGlobal: string, callback: (e) => void) {
        this._coreApiService.goodsRequest
            .then(r => r
                .detachFromClassifier(idGoodsGlobal, idGoodsClassifierGlobal, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e)
                    }
                    else
                        throw new Error(e.message.title);
                })
            );
    }

    setRating(idGoodsGlobal: string, idGoodsClassifierGlobal: string, rate, number, callback: (e) => void) {
        this._coreApiService.goodsRequest
            .then(r => r
                .setRating(idGoodsGlobal, idGoodsClassifierGlobal, rate, (e) => {
                    if (e.respType === 'isCompleted') {
                        callback?.(e)
                    }
                    else
                        throw new Error(e.message.title);
                })
            );
    }

    convolute(convolution: IGoodsConvolution, callback?: (e) => void, failedCallback?: (e) => void) {
        this._coreApiService.goodsRequest.then(r => r.convolute(convolution, (e) => {
            if (e.respType === 'isCompleted') {
                callback?.(e)
            }
            else
            {
                failedCallback?.(e)
                throw new Error(e.message.title);
            }
        }));
    }
    
    getGoodsByBarcode(externalBarcode: string, callback: (data: IGoodsByIdDTO[]) => void) {
        this._coreApiService.goodsRequest
            .then(r => r.getGoodsByBarcode(externalBarcode, (e) => {
                if (e.respType === 'isCompleted') {
                    callback(e.data)
                } else {
                    throw new Error(e.message.text);
                }
            }))
        }
    
    getGoodsByBarcodeWithGosContract(externalBarcode: string, idGosContactGlobal: string, callback: (data: IGoodsByIdDTO[]) => void) {
        this._coreApiService.goodsRequest
            .then(r => r.getGoodsByBarcodeWithGosContract(externalBarcode, idGosContactGlobal, (e) => {
                if (e.respType === 'isCompleted') {
                    callback(e.data)
                } else {
                    throw new Error(e.message.text);
                }
            }))
        }

    getGoodsByCode(code: string, callback: (data: IGoodsByIdDTO[]) => void) {
        this._coreApiService.goodsRequest
            .then(r => r.getGoodsByCode(code, (e) => {
                if (e.respType === 'isCompleted') {
                    callback(e.data)
                } else {
                    callback(e.data)
                    throw new Error(e.message.text);
                }
            }))
        }

    getGoodsByCodeWithGosContract(code: string, idGosContactGlobal: string, callback: (data: IGoodsByIdDTO[]) => void) {
        this._coreApiService.goodsRequest
            .then(r => r.getGoodsByCodeWithGosContract(code, idGosContactGlobal, (e) => {
                if (e.respType === 'isCompleted') {
                    callback(e.data)
                } else {
                    callback(e.data)
                    throw new Error(e.message.text);
                }
            }))
        }

    getViewByName(filter: IViewBody, callback?: (data: IGoodsViewDTO[], totalCount: number,) => void, signal?: AbortSignal | null) {
        this._coreApiService.goodsRequest
            .then(r => r
                .getViewByName(filter, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e.data.entities, e.data.totalCount);
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e?.message.title ?? 'DictionaryDataProvider getViewByName !isCompleted');
                },signal)
            )
            .catch((e) => {
                throw new Error(e?.message.text ?? 'getViewByName DictionaryDataProvider')
            });
    }
    
    getDistinctViewByStore(filter: IViewBody, callback?: (data: IGoodsViewDTO[], totalCount: number,) => void, signal?: AbortSignal | null) {
        this._coreApiService.goodsRequest
            .then(r => r
                .getDistinctViewByStore(filter, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e.data.entities, e.data.totalCount);
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e?.message.title ?? 'DictionaryDataProvider getDistinctViewByStore !isCompleted');
                },signal)
            )
            .catch((e) => {
                throw new Error(e?.message.text ?? 'getDistinctViewByStore DictionaryDataProvider')
            });
    }

    getViewByNameSmart(filter: IViewBody, callback?: (data: IGoodsViewDTO[], totalCount: number,) => void, signal?: AbortSignal | null) {
        this._coreApiService.goodsRequest
            .then(r => r
                .getViewByNameSmart(filter, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e.data.entities, e.data.totalCount);
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e?.message.title ?? 'DictionaryDataProvider getViewByNameSmart !isCompleted');
                },signal)
            )
            .catch((e) => {
                throw new Error(e?.message.text ?? 'getViewByNameSmart DictionaryDataProvider')
            });
    }
    
    getViewCustom(filter: IViewBody, callback?: (data: IGoodsViewDTO[], totalCount: number,) => void) {
        this._coreApiService.goodsRequest
            .then(r => r
                .getViewCustom(filter, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e.data.entities, e.data.totalCount);
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e?.message.title ?? 'DictionaryDataProvider getViewCustom !isCompleted');
                })
            )
            .catch((e) => {
                throw new Error(e?.message.text ?? 'getViewCustom DictionaryDataProvider')
            });
    }

    // Использовать только paramFilter.IdGoodsClassifierGlobal
    getViewClassified(filter: IViewBody, callback?: (data: IGoodsClassified2ViewDTO[], totalCount: number,) => void) {
        this._coreApiService.goodsRequest
            .then(r => r
                .getViewClassified(filter, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.(e.data.entities, e.data.totalCount);
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e?.message.title ?? 'DictionaryDataProvider getViewClassified !isCompleted');
                })
            )
            .catch((e) => {
                throw new Error(e?.message.text ?? 'getViewClassified DictionaryDataProvider')
            });
    }

    getWtruCodeGroup(idGlobal: string, callback?: (entity: IGoodsWtruCodeGroupDTO) => void, fallback?: () => void) {
        this._coreApiService.goodsRequest
            .then(r =>
                r.getWtruCodeGroup(idGlobal, (e) => {
                    try {
                        if (e.respType === 'isCompleted') {
                            callback?.(e.data);
                        } else {
                            if (fallback) fallback()
                            else
                                throw new Error(e?.message.title ?? 'DictionaryDataProvider getWtruCodeGroup !isCompleted');
                        }
                    } catch (error) {
                        if (fallback) fallback()
                        else
                            console.error(error);
                    }
                },
                    (e) => {
                        fallback?.();
                    })
            );
    }

}
